import { Panel, StatusPill } from "@/components/lux";
import { MoneyField, FieldRow, Line, TextField, NumField, Divider } from "./fields";
import { Car } from "lucide-react";

export default function VehiclePanel({ ws, set, totals, internal }) {
  return (
    <Panel label="Vehicle" title={ws.vehicle_desc || "Vehicle"} icon={Car} testid="desk-vehicle-panel">
      <div className="space-y-3">
        {!ws.vehicle_id && (
          <div className="grid grid-cols-2 gap-3">
            <TextField value={ws.vehicle_desc} onChange={(v) => set({ vehicle_desc: v })} placeholder="Year Make Model" testid="desk-vehicle-desc" />
            <TextField value={ws.vehicle_vin} onChange={(v) => set({ vehicle_vin: v })} placeholder="VIN" testid="desk-vehicle-vin" />
          </div>
        )}
        <div className="flex items-center gap-2 flex-wrap text-xs text-muted-foreground">
          {ws.vehicle_stock && <span className="px-2 py-0.5 rounded-full border border-border">Stock {ws.vehicle_stock}</span>}
          {ws.vehicle_vin && <span className="px-2 py-0.5 rounded-full border border-border font-mono">{ws.vehicle_vin}</span>}
          {ws.vehicle_odometer ? <span className="px-2 py-0.5 rounded-full border border-border tnum">{Number(ws.vehicle_odometer).toLocaleString()} km</span> : null}
          {ws.vehicle_days_in_stock ? <StatusPill status="days" tone={ws.vehicle_days_in_stock > 90 ? "red" : ws.vehicle_days_in_stock > 45 ? "amber" : "green"}>{ws.vehicle_days_in_stock} days in stock</StatusPill> : null}
        </div>

        <Divider />
        <FieldRow label="Selling price">
          <MoneyField value={ws.selling_price} onChange={(v) => set({ selling_price: v })} testid="desk-selling-price" />
        </FieldRow>
        <FieldRow label="Discount" hint="Comes off the price before tax">
          <MoneyField value={ws.discount} onChange={(v) => set({ discount: v })} testid="desk-discount" />
        </FieldRow>
        <FieldRow label="Rebate — before tax">
          <MoneyField value={ws.rebate_before_tax} onChange={(v) => set({ rebate_before_tax: v })} testid="desk-rebate-before" />
        </FieldRow>
        <FieldRow label="Rebate / credit — after tax">
          <MoneyField value={ws.rebate_after_tax} onChange={(v) => set({ rebate_after_tax: v })} testid="desk-rebate-after" />
        </FieldRow>
        <Line label="Net selling price" value={totals.selling_price_net} bold gold testid="desk-net-price" />

        {internal && (
          <>
            <Divider />
            <div className="rounded-2xl border border-border bg-white/[0.02] p-3.5 space-y-2.5" data-testid="desk-cost-basis-block">
              <div className="label-mono">Internal — cost basis</div>
              <FieldRow label="Landed cost" hint="Purchase + fees + recon (from the shop)">
                <MoneyField value={ws.cost_basis} onChange={(v) => set({ cost_basis: v })} testid="desk-cost-basis" />
              </FieldRow>
              <FieldRow label="Pack">
                <MoneyField value={ws.pack} onChange={(v) => set({ pack: v })} testid="desk-pack" />
              </FieldRow>
              {totals.over_allowance > 0 && <Line label="Over-allowance on trade" value={-totals.over_allowance} negative muted />}
              <Line label="Front-end gross" value={totals.front_gross} bold gold testid="desk-front-gross" />
            </div>
          </>
        )}
      </div>
    </Panel>
  );
}
